import { render } from "./CompareItemsModal.vue?vue&type=template&id=58613698&ts=true"
import script from "./CompareItemsModal.vue?vue&type=script&lang=ts"
export * from "./CompareItemsModal.vue?vue&type=script&lang=ts"

import "./CompareItemsModal.vue?vue&type=style&index=0&id=58613698&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__